var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  classname: "ml8",
  width: 16,
  height: 8,
  viewBox: "0 0 16 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36",
  d: "M15.907 3.73L12.352.084a.272.272 0 00-.324-.052.305.305 0 00-.176.3v2.334H.3a.272.272 0 00-.213.094.348.348 0 00-.083.24v2a.347.347 0 00.083.239.272.272 0 00.213.094h11.552v2.334a.317.317 0 00.176.3.265.265 0 00.324-.062l3.555-3.688a.363.363 0 00.092-.25.35.35 0 00-.092-.237z",
  fill: "#0068ff"
})));
export default __webpack_public_path__ + "static/media/rightBlueIcon.b30f872e.svg";
export { SvgComponent as ReactComponent };